// Combobox de alumnos con búsqueda por tecleo. Mejora progresivamente el
// formulario data-combo-alumno: filtra la lista al escribir (sin acentos ni
// mayúsculas) y al elegir un alumno fija el id y envía el formulario.

// Rango de marcas diacríticas combinantes (U+0300–U+036F), sin literales.
const DIACRITICOS = new RegExp("[\\u0300-\\u036f]", "g")
const normalizar = (s) =>
  s.normalize("NFD").replace(DIACRITICOS, "").toLowerCase().trim()

export function initComboAlumno() {
  const form = document.querySelector("[data-combo-alumno]")
  if (!form) return

  const input = form.querySelector("[data-combo-input]")
  const hidden = form.querySelector("[data-combo-value]")
  const lista = form.querySelector("[data-combo-list]")
  if (!input || !hidden || !lista) return

  const opciones = Array.from(lista.querySelectorAll("[data-combo-option]"))
  const grupos = Array.from(lista.querySelectorAll("[data-combo-group]"))
  opciones.forEach((li) => (li.dataset.norm = normalizar(li.textContent)))

  const abrir = () => lista.classList.remove("hidden")
  const cerrar = () => lista.classList.add("hidden")

  const filtrar = () => {
    const q = normalizar(input.value)
    opciones.forEach((li) => {
      const visible = q === "" || li.dataset.norm.includes(q)
      li.classList.toggle("hidden", !visible)
    })
    // Oculta el encabezado de grupo si no le quedó ningún alumno visible.
    grupos.forEach((h) => {
      let algo = false
      let el = h.nextElementSibling
      while (el && el.dataset.comboOption !== undefined) {
        if (!el.classList.contains("hidden")) algo = true
        el = el.nextElementSibling
      }
      h.classList.toggle("hidden", !algo)
    })
    abrir()
  }

  const elegir = (li) => {
    hidden.value = li.dataset.id
    input.value = li.textContent.trim()
    cerrar()
    if (form.requestSubmit) form.requestSubmit()
    else form.submit()
  }

  input.addEventListener("input", filtrar)
  input.addEventListener("focus", () => {
    input.select() // permite teclear encima del alumno ya elegido
    abrir()
  })
  lista.addEventListener("mousedown", (e) => {
    const li = e.target.closest("[data-combo-option]")
    if (li) {
      e.preventDefault()
      elegir(li)
    }
  })
  document.addEventListener("click", (e) => {
    if (!form.contains(e.target)) cerrar()
  })
}
